/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import styled, { keyframes, css } from 'styled-components';
import { useState } from 'react';
import CountUp from 'react-countup';
import KeyboardArrowDown from '@icon/KeyboardArrowDown';
import imageHelper from '@utils/imageHelper';
import textHelper from '@utils/textHelper';
import useTimeout from '@hooks/useTimeout';
import DateTimer from './DateTimer';

const Header = styled.section`
  position: relative;
  overflow: hidden;
  height: 568px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(229, 244, 255, 0.44) 100%
  );
  @media only screen and (max-width: 540px) {
    max-height: 432px;
  }
`;

const Content = styled.div`
  max-width: 750px;
  margin: auto;
  padding-top: 64px;
  text-align: center;
`;

const FrameLeft = styled.img`
  position: absolute;
  left: 0px;
  bottom: 0px;
  transform: ${({ mounted }) => `translateX(${mounted ? 0 : -300}px)`};
  opacity: ${({ mounted }) => (mounted ? 1 : 0)};
  transition: transform 400ms ease-out, opacity 400ms ease-out;
  @media only screen and (max-width: 540px) {
    max-height: 190px;
  }
`;

const FrameRight = styled.img`
  position: absolute;
  @media only screen and (max-width: 540px) {
    display: none;
  }
  right: 0px;
  bottom: 0px;
  transform: ${({ mounted }) => `translateX(${mounted ? 0 : 300}px)`};
  opacity: ${({ mounted }) => (mounted ? 1 : 0)};
  transition: transform 800ms ease-out, opacity 800ms ease-out;
`;

const Heading = styled.span`
  font-weight: bold;
  font-size: 48px;
  line-height: 120%;
  color: #3c4852;
  @media only screen and (max-width: 540px) {
    font-size: 32px;
  }
`;

const Amount = styled(CountUp)`
  font-weight: bold;
  font-size: 56px;
  line-height: 120%;
  color: #08bd80;
  @media only screen and (max-width: 540px) {
    font-size: 32px;
  }
`;

const SubText = styled.p`
  font-weight: normal;
  font-size: 24px;
  line-height: 150%;
  text-align: center;
  margin: auto;
  margin-top: 30px;
  max-width: 720px;
  color: #3c4852;
  @media only screen and (max-width: 540px) {
    font-size: 16px;
    margin: 24px 16px;
  }
`;

const keyFrameArrow = keyframes`
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-10px);
  }
`;

const animationArrow = () =>
  css`
    ${keyFrameArrow} 800ms infinite  alternate
  `;

const ArrowContainer = styled.div`
  animation: ${({ mounted }) => (mounted ? animationArrow : 'initial')};
  margin-top: 24px;
  margin-bottom: 88px;
  animation-delay: ${({ mounted }) => (mounted ? 1200 : 0)}ms;
  animation-timing-function: ease-in-out;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 540px) {
    margin-bottom: 48px;
  }
`;

const currencySymbol = textHelper.currencySymbolMap('INR');
const countUpFormat = (num) => textHelper.commasIndianFormat(num);

const ProdigyHeader = ({ dataSet }) => {
  const [mounted, setMounted] = useState(false);

  useTimeout(() => setMounted(true), 0);

  const { header } = dataSet;
  const headerData = header || {};

  return (
    <>
      <Header>
        <FrameLeft
          src={imageHelper.getImage('prodigy/frame-left.svg')}
          mounted={mounted}
        />
        <FrameRight
          src={imageHelper.getImage('prodigy/frame-right.svg')}
          mounted={mounted}
        />
        <Content>
          <Heading>
            {headerData.title}
            {headerData.isAmountAnim && (
              <Amount
                start={headerData.start}
                end={headerData.end}
                formattingFn={(num) => `${currencySymbol}${countUpFormat(num)}`}
                duration={1}
              />
            )}
          </Heading>
          <SubText>{headerData.subTitle}</SubText>
        </Content>
        <DateTimer mounted={mounted} headerData={headerData} />
      </Header>
      <ArrowContainer mounted={mounted}>
        <KeyboardArrowDown size="24px" color="#3C4852" />
      </ArrowContainer>
    </>
  );
};

export default ProdigyHeader;
